import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from "src/app/services/auth.service";
import { isArray } from 'util';
import { API_URL } from "../../../environments/api-url";
import * as global from '../global';
import * as moment from 'moment';
import { OpenReleaseDialogComponent } from '../../includes/open-release-dialog/open-release-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ReleaseService } from './release.service';
import { Location } from '@angular/common';
import { DialogConfirmationComponent } from '../census-patient-list/dialog-confirmation/dialog-confirmation.component';



export interface notes {
  createdAt: string;
  note: string;
}

@Component({
  selector: 'app-release',
  templateUrl: './release.component.html',
  styleUrls: ['./release.component.css']
})
export class ReleaseComponent implements OnInit {

  currentUser: any = null;

  // displayedColumns: string[] = ['createdAt', 'note'];
  transcriptionsGroupingKey: string = 'createdAt';
  // dataSource = new MatTableDataSource();
  dataSource: any;
  // @ViewChild(MatSort) sort: MatSort;
  notes: any;
  admin = false;
  constructor(private httpclient: HttpClient,
    private _authService: AuthService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private router: Router,
    private releaseService: ReleaseService,
    private _location: Location
  ) { }

  ngOnInit(): void {
    // this.dataSource.sort = this.sort;

    this.getNote();

    if (window.location.pathname.includes('company')) {
      this.admin = true;
    }
  }

  getNote() {
    this.releaseService.getNotes().subscribe((response: any) => {
      if (response.status == 200) {
        this.notes = response.data;

        // this.dataSource = new MatTableDataSource(this.notes);

        console.log('response', this.notes);
      } else {
        console.log('something went wrong!');
      }
    });
  }

  openReleaseDialog(addNotes) {
    const dialogRef = this.dialog.open(OpenReleaseDialogComponent, {
      width: '800px',
      data: addNotes
    });
    dialogRef.afterClosed().subscribe(async (addNotes) => {
      console.log('addnotes', addNotes);
      if (addNotes) {
        this.releaseService.addNotes(addNotes).subscribe((response: any) => {
          if (response.status == 200) {
            this.notes.push(addNotes);
            // console.log('response', response);
            this.toastr.success('Saved');
            this.getNote();

          }
        });
      } else {
        console.log('something went wrong!');
      }

    });
  }
  openReleaseDialogForEdit(note, noteId) {
    const dialogRef = this.dialog.open(OpenReleaseDialogComponent, {
      width: '800px',
      data: note
    });
    dialogRef.afterClosed().subscribe(async (addNotes) => {
      console.log('addnotes', addNotes);
      if (addNotes) {
        this.releaseService.editNote(addNotes, noteId._id).subscribe((response: any) => {
          if (response.status == 200) {
            // console.log('response', response);
            this.toastr.success('Saved');
            this.getNote();

          }
        });
      } else {
        console.log('something went wrong!');
      }

    });
  }

  deleteNote(id, index) {
    let dialogRef = this.dialog.open(DialogConfirmationComponent, {
      data: {
        message: 'Are you sure you want to delete this Release Note?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === "true") {
        this.releaseService.deleteNote(id).subscribe((response: any) => {
          if (response.status == 200) {
            // console.log('response', response);
            this.toastr.success('Deleted Successfully');
            this.notes.splice(index, 1);
          }
        });
      }
    })
  }
  goBack() {
    this._location.back();
  }

}
